import React from 'react';
import { MessageCircleIcon, PhoneIcon, MessageSquareIcon, MailIcon, ZapIcon, InfoIcon } from 'lucide-react';
import { ChannelType } from '../../types/whatsapp';
interface ChannelBadgeProps {
  channel: ChannelType;
  size?: 'sm' | 'md';
  showLabel?: boolean;
}
export function ChannelBadge({
  channel,
  size = 'md',
  showLabel = false
}: ChannelBadgeProps) {
  const config = {
    whatsapp: {
      icon: MessageCircleIcon,
      color: 'text-green-600',
      bg: 'bg-green-100',
      label: 'WhatsApp'
    },
    sms: {
      icon: MessageSquareIcon,
      color: 'text-purple-600',
      bg: 'bg-purple-100',
      label: 'SMS'
    },
    voice: {
      icon: PhoneIcon,
      color: 'text-blue-600',
      bg: 'bg-blue-100',
      label: 'Voice'
    },
    email: {
      icon: MailIcon,
      color: 'text-orange-600',
      bg: 'bg-orange-100',
      label: 'Email'
    },
    'auto-trigger': {
      icon: ZapIcon,
      color: 'text-yellow-600',
      bg: 'bg-yellow-100',
      label: 'Auto'
    },
    system: {
      icon: InfoIcon,
      color: 'text-gray-500',
      bg: 'bg-gray-100',
      label: 'System'
    }
  };
  const {
    icon: Icon,
    color,
    bg,
    label
  } = config[channel] || config.system;
  const iconSize = size === 'sm' ? 12 : 14;
  return <div className={`inline-flex items-center ${showLabel ? `px-2 py-0.5 rounded-full ${bg}` : ''}`} data-id="element-886">
      <Icon size={iconSize} className={color} data-id="element-887" />
      {showLabel && <span className={`ml-1 text-xs font-medium ${color}`} data-id="element-888">{label}</span>}
    </div>;
}